type ClickEvent = JQuery.ClickEvent;

/**
 * A simple tooltip class for mobile users to toggle the tooltip
 */
export class Tooltip {

  constructor() {
    $('i.fa-info-circle')
      .on('click', (e: ClickEvent) => this.toggleTooltip(e));
  }

  public toggleTooltip(e: ClickEvent): void {
    $(e.currentTarget)
      .find('.js-tooltip')
      .toggle();
  }
}
